import { RestClient } from "../RestClient";

export type B100070FindRequest = {
  tokuiCd: string;
  tokuishitenCd: string;
};

export type B100070FindResponse = {
  tokuiCd: string;
  tokuishitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
  tokuiNm1: string;
  hyojunnonyuKbn: string;
  version: number;
};

export const B100070Find = (props: B100070FindRequest) => {
  return RestClient.get<B100070FindResponse[]>("b100070/find", {
    params: props,
  });
};

export type B100070CreateTokuinonyuList = {
  tokuiCd: string;
  tokuishitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
  hyojunnonyuKbn: string;
} & Partial<{
  version: number;
}>;

export type B100070CreateRequest = {
  b100070CreateFieldList: B100070CreateTokuinonyuList[];
};

// 登録処理
export const B100070Create = (data: B100070CreateRequest) => {
  return RestClient.post("b100070/create", data);
};

export type B100070UpdateTokuinonyuList = {
  tokuiCd: string;
  tokuishitenCd: string;
  defaultNonyuCd: string;
  defaultNonyushitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
  hyojunnonyuKbn: string;
} & Partial<{
  version: number;
}>;

export type B100070UpdateRequest = {
  b100070UpdateFieldList: B100070UpdateTokuinonyuList[];
};

// 更新処理
export const B100070Update = (data: B100070UpdateRequest) => {
  return RestClient.put("b100070/update", data);
};

export type B100070DeleteRequest = {
  tokuiCd: string;
  tokuishitenCd: string;
  nonyuCd: string;
  nonyushitenCd: string;
  version: number;
};

// 削除処理
export const B100070Delete = (data: B100070DeleteRequest) => {
  return RestClient.delete("b100070/delete", { data: data });
};
